import type { CompanySubscriptionResponse } from '../types';

export const CHECKOUT_POLL_INTERVAL_MS = 2000;
export const CHECKOUT_MAX_ATTEMPTS = 30;

/** What the SERVER's subscription state says about the payment. `paid` is the paid state; `failed` is a payment
 * failure; everything else (still trialing, expired, canceled, no subscription yet) means "not confirmed yet". */
export function checkoutOutcome(subscription: CompanySubscriptionResponse | null): 'paid' | 'failed' | 'pending' {
  if (!subscription) return 'pending';
  if (subscription.paymentFailed || subscription.effectiveState === 'PastDueGrace' || subscription.effectiveState === 'PastDueRestricted') {
    return 'failed';
  }
  return subscription.effectiveState === 'Active' || subscription.effectiveState === 'PendingChange' ? 'paid' : 'pending';
}
